import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CroudComponent } from './croud-liste-prix/croud.component';
import { PrixService, Prix } from './prix.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ParametreService } from '../main-parametre/parametre.service';
import * as feather from 'feather-icons';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-liste-prix',
  templateUrl: './liste-prix.component.html',
  styleUrls: ['./liste-prix.component.scss']
})
export class ListePrixComponent implements OnInit, AfterViewInit {
  @ViewChild('croud') croudComponent!: CroudComponent;
  prixList: Prix[] = [];
  isLoading: boolean = false;
  error: string | null = null;
  idStation: number | null = null;

private subscriptions = new Subscription();

  constructor(
    private prixService: PrixService,
    private toastr: ToastrService,
    private router: Router,
    private parametreService: ParametreService
  ) {}

  ngOnInit(): void {
     const modalSub =    this.parametreService.openModal$.subscribe(({ component, action }) => {
      if (component === 'liste-prix' && action === 'add' && this.idStation !== null) {
        this.openCroudModal();
      }
    });
  this.subscriptions.add(modalSub);
    this.loadUserData();
 
  }

  ngAfterViewInit(): void {
    feather.replace(); 
    this.croudComponent.prixAdded.subscribe(() => {
      if (this.idStation !== null) {
        this.loadPrix();
      }
    });
    this.croudComponent.prixUpdated.subscribe((updatedPrix: Prix) => {
      const index = this.prixList.findIndex(p => p.id === updatedPrix.id);
      if (index !== -1) {
        this.prixList[index] = { ...this.prixList[index], ...updatedPrix };
      }
    });
  }

ngOnDestroy(): void {
  this.subscriptions.unsubscribe();
}
  loadUserData(): void {
    const user = localStorage.getItem('currentUser');
    if (user) {
      const currentUser = JSON.parse(user);
      if (currentUser?.stations?.length > 0) {
        this.idStation = currentUser.stations[0].id;
        this.loadPrix();
      } else {
        this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
        this.router.navigate(['/create-station']);
      }
    } else {
      this.toastr.error('Utilisateur non connecté.', 'Erreur');
      this.router.navigate(['/pages/authentication/login-v2']);
    }
  }

  loadPrix(): void {
    if (this.idStation === null) {
      this.error = 'Aucune station disponible.';
      return;
    }
    this.isLoading = true;
    this.prixService.getPrix(this.idStation).subscribe({
      next: (data: Prix[]) => {
        this.prixList = data || [];
        this.isLoading = false;
      },
      error: (err) => {
        this.error = err.message;
        this.toastr.error(err.message, 'Erreur');
        this.isLoading = false;
      }
    });
  }

  openCroudModal(): void {
    if (this.idStation === null) {
      this.toastr.error('Impossible d\'ajouter un prix : aucune station disponible.', 'Erreur');
      return;
    }
    this.croudComponent.openModal('ajouter');
  }

  openEtatModal(prix: Prix, event?: Event, action: 'update' | 'etat' = 'etat'): void {
    if (this.idStation === null) {
      this.toastr.error('Impossible de modifier : aucune station disponible.', 'Erreur');
      return;
    }
    if (event) {
      event.preventDefault();
    }
    this.croudComponent.openModal(action, prix);
  }
  onAddClick(): void {
    this.openCroudModal();
  }

  addList(): void {
      this.parametreService.triggerModal('liste-prix', 'add');
  }
}
